<div class="d-flex flex-column justify-content-between h-100">
    <div class="marketplace-overview-section row position-relative my-4">
        <div class="col-3 pt-1">
            <div class="rounded-circle m-auto marketplace-badge-icon marketplace-badge-icon-new"></div>
        </div>
        <div class="col-6">
            <div class="font-weight-bold">{{ms.ordersByRange.today.length}} <span cvLocalizedText langSection="Command_Center" langKey="New_Orders">New Orders</span></div>
            <div class="text-muted" cvLocalizedText langSection="Command_Center" langKey="Last_24_Hours">Last 24 Hours</div>
        </div>
        <div class="col-3 position-static">
            <div id="lastDayOrdersBtn" class="btn btn-text ml-auto clickable stretched-link" (click)="openOrders('today')" cvLocalizedText langSection="Common" langKey="View">View</div>
        </div>
    </div>
    <div class="marketplace-overview-separator border-bottom border-black-50 mx-n4"></div>
    <div class="marketplace-overview-section row position-relative my-4">
        <div class="col-3 pt-1">
            <div class="rounded-circle m-auto marketplace-badge-icon marketplace-badge-icon-pending"></div>
        </div>
        <div class="col-6">
            <div class="font-weight-bold">{{ms.ordersByStatus.processing.length}} <span cvLocalizedText langSection="Command_Center" langKey="Orders">Orders</span></div>
            <div class="text-muted" cvLocalizedText langSection="Command_Center" langKey="Awaiting_Process">Awaiting Process</div>
        </div>
        <div class="col-3 position-static">
            <div id="waitProcessOrdersBtn" class="btn btn-text ml-auto clickable stretched-link" (click)="openOrders('processing')" cvLocalizedText langSection="Common" langKey="View">View</div>
        </div>
    </div>
    <div class="marketplace-overview-separator border-bottom border-black-50 mx-n4"></div>
    <div class="marketplace-overview-section row position-relative my-4">
        <div class="col-3 pt-1">
            <div class="rounded-circle m-auto marketplace-badge-icon marketplace-badge-icon-low-stock"></div>
        </div>
        <div class="col-6">
            <div class="font-weight-bold">{{ms.productsLowStock.length}} <span cvLocalizedText langSection="Command_Center" langKey="Items">Items</span></div>
            <div class="text-muted" cvLocalizedText langSection="Command_Center" langKey="Low_In_Stock">Low in Stock</div>
        </div>
        <div class="col-3 position-static">
            <div id="lowStockProductsBtn" class="btn btn-text ml-auto clickable stretched-link" (click)="openProducts('LowStock')" cvLocalizedText langSection="Common" langKey="View">View</div>
        </div>
    </div>
    <div class="marketplace-overview-separator border-bottom border-black-50 mx-n4"></div>
    <div class="marketplace-overview-section row position-relative my-4">
        <div class="col-3 pt-1">
            <div class="rounded-circle m-auto marketplace-badge-icon marketplace-badge-icon-no-stock"></div>
        </div>
        <div class="col-6">
            <div class="font-weight-bold">{{ms.productsOutOfStock.length}} <span cvLocalizedText langSection="Command_Center" langKey="Items">Items</span></div>
            <div class="text-muted" cvLocalizedText langSection="Command_Center" langKey="Out_Of_Stock">Out of Stock</div>
        </div>
        <div class="col-3 position-static">
            <div id="outOfStockProductsBtn" class="btn btn-text ml-auto clickable stretched-link" (click)="openProducts('OutOfStock')" cvLocalizedText langSection="Common" langKey="View">View</div>
        </div>
    </div>
</div>